import { URI_REPORT } from '@/config/config'

export default async ({ rootState }, { query }) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const client = rootState['DATA-ACCESS'].client;
  query.clientId = client._id;

  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(query)
  }

  const userLoginInfoResult = await fetch(`${URI_REPORT}reports/occupation-rate`, opts)
  const jsonResult = await userLoginInfoResult.json()

  if (jsonResult.errors) {
    return Promise.reject(jsonResult.errors)
  }
  
  return jsonResult
}